import { useState } from 'react';
import { authService } from '../utils/authService';
import axiosInstance from '../utils/axiosConfig';

export const useUsers = () => {
  const [users, setUsers] = useState([]);
  const [clients, setClients] = useState([]);

  const fetchUsers = async () => {
    const response = await axiosInstance.get('/users', {
      params: { role: 'user' }
    });
    setUsers(response.data);
  };
  
  const fetchClients = async () => {
    const response = await axiosInstance.get('/clients');
    setClients(response.data);
  };
  

  return { users, clients, fetchUsers, fetchClients };
};
